<template>
  <OrConfirmV3
    ref="confirm"
    class="delete-version-modal"
    data-test="delete-version-modal"
    confirm-type="d"
    :title-text="$t('deleteVersion')"
    :loading="isLoading"
    :confirm-button-text="$t('delete')"
    :cancel-button-text="$t('keep')"
    :confirmation-text="confirmText"
    :text-confirmation-error="$t('deleteVersionModal.codeDoNotMatch')"
    :text-confirmation-placeholder="$t('deleteVersionModal.enterCodeToConfirm')"
    @confirm="emit('confirm')"
  >
    <i18n-t
      keypath="deleteVersionModal.text"
      scope="global"
      tag="span"
      class="typography-body-2-regular"
    >
      <template #version>
        <span class="typography-body-2-bold"> {{ version }} </span>
      </template>
    </i18n-t>
    <br>
    <br>
    <i18n-t
      keypath="deleteVersionModal.textConfirmationLabel"
      scope="global"
      tag="span"
      class="input-label"
    >
      <template #code>
        <span class="typography-body-2-bold"> {{ confirmText }}</span>
      </template>
    </i18n-t>
  </OrConfirmV3>
</template>
<script setup lang="ts">
import { OrConfirmV3 } from '@onereach/ui-components';
import { ref, watch } from 'vue';

const props = defineProps<{
  isOpened: boolean;
  isLoading: boolean;
  version?: string;
  confirmText?: string;
}>();

const emit = defineEmits<{
  (event: 'confirm'): void;
}>();

const confirm = ref<InstanceType<typeof OrConfirmV3>>();

watch(() => props.isOpened, (val) => {
  val ? confirm.value?.open() : confirm.value?.close();
}, { immediate: true });
</script>

<style lang="scss" scoped>
.input-label + ::v-deep(div) {
  margin-top: 8px;
}
</style>
